export default function getMemberNickname(member, locale) {
    const fullname = `${locale.getProperty(member, 'lastname') || ''} ${locale.getProperty(member, 'name') || ''}`;

    return !!fullname
        ? fullname
            .split(' ')
            .map((text) => text.slice(0, 1).toUpperCase())
            .join('')
        : ''
    ;
}
